export function filterStudentsByAlerts(students, alerts, chosenAlertType, chosenAlertStatus) {
  if (!alerts ||  chosenAlertType === "" || chosenAlertStatus === "" ) {
    return students;
  }

  const matchingStudents = new Set();
  
  alerts.forEach(group => {
    const hasMatchingAlert = group.alerts?.some(alert => {
      const typeMatch = chosenAlertType === "all" || alert.type?.kind === chosenAlertType;
      const statusMatch = chosenAlertStatus === "all" || 
                         (chosenAlertStatus === "seen" && alert.read) ||
                         (chosenAlertStatus === "unseen" && !alert.read);
      return typeMatch && statusMatch;
    });
    
    if (hasMatchingAlert && group.student?.email) {
      matchingStudents.add(group.student.email);
    }
  });

  return students.filter(student => matchingStudents.has(student.name));
}